var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanaSaleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 91,
    viewBox: "0 0 242 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 91,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5529 66.0012C11.5529 66.0012 0 66.3607 0 78.5C0 90.6393 11.5529 90.9989 11.5529 90.9989H20.6292V86.1406H11.7699C11.7699 86.1406 4.94034 85.7393 4.94034 78.5C4.94034 71.2607 11.7699 70.8595 11.7699 70.8595H20.6292V66.0012H11.5529ZM37.9902 66.0012L30.0971 90.9989H35.7094L42.2668 70.7075L48.8161 90.9989H54.4283L46.5352 66.0012H37.9914H37.9902ZM63.8951 66.0012V90.9989H68.8073L68.7663 73.15L78.5555 90.9989H85.0566V66.0012H80.1444V83.7329L70.3341 66.0012H63.8963H63.8951ZM102.397 66.0012L94.5035 90.9989H100.116L106.673 70.7075L113.222 90.9989H118.835L110.942 66.0012H102.397ZM135.727 66.0012C135.727 66.0012 128.31 66.167 128.31 73.455C128.31 80.743 135.727 80.9089 135.727 80.9089H142.186C142.186 80.9089 145.356 80.8602 145.356 83.5253C145.356 86.1893 142.186 86.1418 142.186 86.1418H129.233V91H142.879C142.879 91 150.297 90.8342 150.297 83.5253C150.297 76.2165 142.879 76.0506 142.879 76.0506H136.42C136.42 76.0506 133.25 76.0993 133.25 73.455C133.25 70.8108 136.42 70.8595 136.42 70.8595H149.373V66.0012H135.727ZM167.644 66.0012L159.751 90.9989H165.363L171.92 70.7075L178.47 90.9989H184.082L176.189 66.0012H167.645H167.644ZM193.549 90.9989H198.461H213.24V86.1406H198.461V66.0012H193.549V86.1406V90.9989ZM222.309 76.0494V80.9077H242V76.0494H222.309ZM222.309 86.1394V90.9977H242V86.1394H222.309ZM222.309 66V70.8583H242V66H222.309Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.967 46C118.967 25.6408 99.9444 25.0371 99.9444 25.0371H85V33.1854H99.5863C99.5863 33.1854 110.832 33.8581 110.832 46H118.967Z",
    fill: "#61BC18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.967 0C118.967 20.3592 99.9444 20.9629 99.9444 20.9629H85V12.8146H99.5863C99.5863 12.8146 110.832 12.142 110.832 0H118.967Z",
    fill: "#61BC18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.033 46C123.033 25.6408 142.055 25.0371 142.055 25.0371H157V33.1854H142.414C142.414 33.1854 131.168 33.8581 131.168 46H123.033Z",
    fill: "#61BC18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.033 0C123.033 20.3592 142.055 20.9629 142.055 20.9629H157V12.8146H142.414C142.414 12.8146 131.168 12.142 131.168 0H123.033Z",
    fill: "#AD3EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanaSaleLogo);
export default __webpack_public_path__ + "static/media/CanaSaleLogo.b9eb6bad31f6a5b85a6f446c5680ee6f.svg";
export { ForwardRef as ReactComponent };